import { arrayToSimpleObj } from '../utils';

export const dataSourceOptions = [
  {
    value: 'App Store',
    source_name_en: 'App Store',
    source_name_cn: 'App Store',
  },
  {
    value: 'Google Play',
    source_name_en: 'Google Play',
    source_name_cn: 'Google Play',
  },
  {
    value: 'Steam',
    source_name_en: 'Steam',
    source_name_cn: 'Steam',
  },
  {
    value: 'Opencritic',
    source_name_en: 'Opencritic',
    source_name_cn: 'Opencritic',
  },
  {
    value: 'Metacritic',
    source_name_en: 'Metacritic',
    source_name_cn: 'Metacritic',
  },
  {
    value: 'Facebook',
    source_name_en: 'Facebook',
    source_name_cn: 'Facebook',
  },
  {
    value: 'Twitter',
    source_name_en: 'X',
    source_name_cn: 'X',
  },
  {
    value: 'Reddit',
    source_name_en: 'Reddit',
    source_name_cn: 'Reddit',
  },
  {
    value: 'Youtube',
    source_name_en: 'Youtube',
    source_name_cn: 'Youtube',
  },
  {
    value: 'Instagram',
    source_name_en: 'Instagram',
    source_name_cn: 'Instagram',
  },
  {
    value: 'Discord',
    source_name_en: 'Discord',
    source_name_cn: 'Discord',
  },
  {
    value: 'Twitch',
    source_name_en: 'Twitch',
    source_name_cn: 'Twitch',
  },
  {
    value: 'youtube_gaming',
    source_name_en: 'Youtube Gaming',
    source_name_cn: 'Youtube Gaming',
  },
  {
    value: 'facebook_gaming',
    source_name_en: 'Facebook Gaming',
    source_name_cn: 'Facebook Gaming',
  },
  {
    value: 'VK',
    source_name_en: 'VK',
    source_name_cn: 'VK',
  },
  {
    value: 'cafe',
    source_name_en: 'Naver Cafe',
    source_name_cn: 'Naver Cafe',
  },
  {
    value: 'Tiktok',
    source_name_en: 'Tiktok',
    source_name_cn: 'Tiktok',
  },
  {
    value: 'Ruliweb',
    source_name_en: 'Ruliweb',
    source_name_cn: 'Ruliweb',
  },
  {
    value: 'taptap',
    source_name_en: 'Taptap io',
    source_name_cn: 'Taptap国际版',
  },
  {
    value: 'mi',
    source_name_en: 'Xiaomi Market',
    source_name_cn: '小米应用商店',
  },
  {
    value: 'oppo',
    source_name_en: 'Oppo Store',
    source_name_cn: 'Oppo应用商店',
  },
  {
    value: 'Line',
    source_name_en: 'Line',
    source_name_cn: 'Line',
  },
];

export const dataSourceMapCn = arrayToSimpleObj(
  dataSourceOptions,
  'source_name_cn',
);

export const dataSourceMapEn = arrayToSimpleObj(
  dataSourceOptions,
  'source_name_en',
);

export const dataSourceOptionsEn = dataSourceOptions.map(
  ({ value, source_name_en }) => ({
    text: source_name_en,
    value,
  }),
);
export const dataSourceOptionsCn = dataSourceOptions.map(
  ({ value, source_name_cn }) => ({
    text: source_name_cn,
    value,
  }),
);
